import React, { useState, useRef } from 'react';
import { Formik, Form } from 'formik';
import * as yup from 'yup';
import { useTheme } from 'styled-components';
import { useSelector } from 'react-redux';
import { Auth } from 'aws-amplify';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Collapse from 'react-bootstrap/Collapse';
import Fade from 'react-bootstrap/Fade';

import Button from '../../../components/Button';
import FormInput from '../../../components/FormInput';

import { FormattedMessage } from 'react-intl';

const ProfileSettings = () => {
  const [infoSaved, setInfoSaved] = useState(false);
  const [infoSavedFade, setInfoSavedFade] = useState(false);
  const [loading, setLoading] = useState(false);

  const timeoutRef = useRef();
  const theme = useTheme();

  const cognitoUser = useSelector((state) => state.auth.cognitoUser);

  async function updateCognitoUser({ name, phone }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      await Auth.updateUserAttributes(user, {
        name,
        phone_number: phone,
      });

      return true;
    } catch (error) {
      return false;
    }
  }

  const updateInfo = async ({ name, phone }) => {
    setLoading(true);
    setInfoSaved(false);
    setInfoSavedFade(false);

    if (timeoutRef.current) {
      clearInterval(timeoutRef.current);
      timeoutRef.current = null;
    }

    await updateCognitoUser({
      name,
      phone,
    });

    setLoading(false);
  };

  const validationSchema = yup.object().shape({
    name: yup.string().required('Obligatoriskt fält'),
    email: yup.string().email(),
    phone: yup.string(),
  });

  return (
    <Col>
      <Formik
        validationSchema={validationSchema}
        initialValues={{
          name: cognitoUser.attributes.name,
          email: cognitoUser.attributes.email,
          phone: cognitoUser.attributes.phone_number,
        }}
        onSubmit={updateInfo}
      >
        {({ values, errors, submitCount, handleChange }) => {
          const showErrors = submitCount > 0;
          return (
            <Form>
              <Col>
                <Row>
                  <Col>
                    <FormInput
                      onChange={handleChange('name')}
                      value={values.name}
                      label="Namn"
                      error={showErrors && errors.name}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <FormInput
                      onChange={handleChange('email')}
                      value={values.email}
                      label="E-postaddress"
                      error={showErrors && errors.email}
                      disabled
                    />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <FormInput
                      onChange={handleChange('phone')}
                      value={values.phone}
                      label="Mobilnummer"
                      error={showErrors && errors.phone}
                    />
                  </Col>
                </Row>
              </Col>

              <Collapse
                in={infoSaved}
                onEntered={() => {
                  setInfoSavedFade(true);
                }}
              >
                <Fade
                  timeout={500}
                  in={infoSavedFade}
                  onEntered={() => {
                    timeoutRef.current = setTimeout(() => {
                      setInfoSaved(false);
                      setInfoSavedFade(false);
                    }, 5000);
                  }}
                >
                  <Row className="flex-row-reverse">
                    <Col xs="auto">
                      <p
                        style={{
                          color: theme.colors.darkGrayColor,
                        }}
                      >
                        <FormattedMessage defaultMessage="Dina uppgifter har sparats" />
                      </p>
                    </Col>
                  </Row>
                </Fade>
              </Collapse>

              <Row className="flex-row-reverse mt-2">
                <Col xs="auto">
                  <Button isLoading={loading} type="submit">
                    <FormattedMessage defaultMessage="Spara" />
                  </Button>
                </Col>
              </Row>
            </Form>
          );
        }}
      </Formik>
    </Col>
  );
};

export default ProfileSettings;
